/**
 * Get the settings document
 * @return {Promise<Object>}
 */
export default async function getImageData (url, outputFormat){
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.crossOrigin = 'Anonymous'
    img.src = url
    img.onload = function(){
      const canvas = document.createElement('canvas')
      canvas.height = img.height
      canvas.width = img.width
      canvas.getContext('2d').drawImage(img, 0, 0)

      resolve(canvas.toDataURL(outputFormat || 'image/jpeg'))
    }
  })
}





// WEBPACK FOOTER //
// ./modules/utils/getImageData.js